import {
  SET_NOT_READY_TO_SELL,
  SET_NOT_READY_TO_SELL_ERROR,
  CLEAR_NOT_READY_TO_SELL,
  NOT_READY_TO_SELL_LOADING,
} from "../../constants/action-types";
import {
  getAgencyAgentsNotReadyToSell,
  getAgencyAgentsNotReadyToSellByDirectorID,
} from "../../../services/GraphQl/BDSWebService";

// BUG FIX: Loading should be set to true before the async call, not after dispatching data.

export const setNotReadyToSell = (data) => ({
  type: SET_NOT_READY_TO_SELL,
  payload: data,
});
export const setNotReadyToSellError = (data) => ({
  type: SET_NOT_READY_TO_SELL_ERROR,
  payload: data,
});
export const clearNotReadyToSell = (data) => ({
  type: CLEAR_NOT_READY_TO_SELL,
  payload: data,
});
export const notReadyToSellLoading = (data) => ({
  type: NOT_READY_TO_SELL_LOADING,
  payload: data,
});

export const fetchNotReadyToSellByDirectorID = (directorId) => {
  return async (dispatch) => {
    dispatch(notReadyToSellLoading(true)); // FIX: Set loading before async call
    try {
      let ProResultData = await getAgencyAgentsNotReadyToSellByDirectorID(directorId);
      let ProResult = ProResultData.data
        ? ProResultData.data.getAgencyAgentsNotReadyToSellByDirectorID
        : ProResultData;
      dispatch(setNotReadyToSell(ProResult.data.getAgencyAgentsNotReadyToSellByDirectorID));
    } catch (error) {
      dispatch(setNotReadyToSellError(error.message));
    } finally {
      dispatch(notReadyToSellLoading(false));
    }
  };
};

export const fetchNotReadyToSell = (agencyId) => {
  return async (dispatch) => {
    dispatch(notReadyToSellLoading(true)); // FIX: Set loading before async call
    try {
      let ProResultData = await getAgencyAgentsNotReadyToSell(agencyId);
      let ProResult = ProResultData.data
        ? ProResultData.data.getAgencyAgentsNotReadyToSell
        : ProResultData;
      dispatch(setNotReadyToSell(ProResult));
    } catch (error) {
      dispatch(setNotReadyToSellError(error.message));
    } finally {
      dispatch(notReadyToSellLoading(false));
    }
  };
};

export const clearNotReadyToSellList = () => (dispatch) => {
  dispatch(clearNotReadyToSell([]));
};